import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Paper, withStyles, Fab } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import IndicatorsTable from "./table";
import { withRouter } from "react-router-dom";

const styles = (theme) => ({
	root: {
		position: "relative",
		margin: 36
	},
	fab: {
		position: "fixed",
		top: 0,
		right: 0,
		transform: `translateX(${-10}%) translateY(${130}%)`
	}
});

class IndicatorsDashboard extends Component {
	render() {
		const { classes, history } = this.props;
		return (
			<Row>
				<Col xs={12}>
					<Paper className={classes.root}>
						<Fab className={classes.fab} color={"primary"} onClick={() => null}>
							<AddIcon onClick={() => history.push("/admin/indicators/add")} />
						</Fab>
						<IndicatorsTable />
					</Paper>
				</Col>
			</Row>
		);
	}
}

export default withRouter(withStyles(styles)(IndicatorsDashboard));



// WEBPACK FOOTER //
// ./src/components/admin/indicators/index.js